exports.components = {
  "component---src-activities-index-tsx": () => import("./../../../src/activities/Index.tsx" /* webpackChunkName: "component---src-activities-index-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-hotcake-template-tsx": () => import("./../../../src/templates/HotcakeTemplate.tsx" /* webpackChunkName: "component---src-templates-hotcake-template-tsx" */)
}

